module.exports = __webpack_public_path__ + "static/media/wizualizacja-86.2c8f8319.png";